import { equipmentAPI } from "api";

export const searchEqReserAPI = (payload, page = 0, size = 0, withoutEquipment) => {
    return equipmentAPI.post(`/api/equipmentforreservation?PageNo=${page}&PageSize=${size}&withoutEquipment=${withoutEquipment}`, payload)
        .then((res) => res);
}
